/* Spracheingabe für Pia (30.10.2026). Aufnahme im Browser (MediaRecorder), Erkennung NUR über den eigenen Server
   (POST /api/assistenz/sprache → eigener Whisper). Keine Browser-Spracherkennung, das Audio wird nirgends gespeichert.
   Der erkannte Text kommt ins Eingabefeld, damit man ihn korrigieren kann; optional direkt senden (je Gerät). */
import { Loader2, Mic, Square, X } from 'lucide-react';
import { MAX_SEKUNDEN, useSprachaufnahme, zeit } from '@/lib/sprachaufnahme';

const SCHALTER = 'p1_pia_direkt_senden';

export function direktSendenLesen() {
  try { return localStorage.getItem(SCHALTER) === '1'; } catch (e) { return false; }
}
export function direktSendenSchreiben(an) {
  try { localStorage.setItem(SCHALTER, an ? '1' : '0'); } catch (e) { /* ohne Speicher: gilt nur jetzt */ }
}


export { MAX_SEKUNDEN, useSprachaufnahme, zeit };

/* Knopf neben dem Eingabefeld. */
export function MikrofonKnopf({ onClick, disabled }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} aria-label="Spracheingabe starten" title="Sprechen statt tippen" data-testid="pia-mikro"
      className="inline-flex items-center justify-center min-w-[44px] min-h-[44px] rounded-md border border-input bg-background hover:bg-muted text-foreground disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-marke">
      <Mic className="w-5 h-5" aria-hidden="true" />
    </button>
  );
}

/* Leiste statt Eingabefeld, solange aufgenommen oder erkannt wird. */
export function AufnahmeLeiste({ s }) {
  if (s.zustand === 'erkennen') {
    return (
      <div className="flex-1 flex items-center gap-2 min-h-[44px] px-3 rounded-md border border-input bg-muted/40 text-sm" role="status" data-testid="pia-erkennt">
        <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> Wird erkannt …
      </div>
    );
  }
  return (
    <div className="flex-1 flex items-center gap-2 min-h-[44px] px-3 rounded-md border border-marke/60 bg-marke/5 text-sm" role="status" data-testid="pia-aufnahme">
      <span className="w-2 h-2 rounded-full bg-marke animate-pulse" aria-hidden="true" />
      <span className="whitespace-nowrap">Aufnahme läuft · {zeit(s.sek)}</span>
      <span className="flex-1 h-2 rounded-full bg-muted overflow-hidden" aria-hidden="true">
        <span className="block h-full bg-marke transition-[width] duration-75" style={{ width: `${Math.round(s.pegel * 100)}%` }} />
      </span>
      <button type="button" onClick={s.abbrechen} aria-label="Aufnahme abbrechen" data-testid="pia-aufnahme-abbrechen"
        className="inline-flex items-center justify-center gap-1 min-w-[44px] min-h-[44px] px-2 rounded-md hover:bg-muted"><X className="w-4 h-4" aria-hidden="true" /><span className="hidden sm:inline">Abbrechen</span></button>
      <button type="button" onClick={s.fertig} aria-label="Aufnahme fertig, Text erkennen" data-testid="pia-aufnahme-fertig"
        className="inline-flex items-center justify-center gap-1 min-w-[44px] min-h-[44px] px-3 rounded-md bg-marke text-white hover:opacity-90"><Square className="w-4 h-4" aria-hidden="true" /><span>Fertig</span></button>
    </div>
  );
}
